import AbsCategories from "./AbsCategories";

class CategoriesItem extends AbsCategories {
    constructor(_store={}, _router={}, _el=''){
        super('class CategoriesItem', _store, _router, _el);
    }

    subInit(){
        let watchCategoriesSel = this.watch(this.store.getState, 'selectCategories', this.isEqual);
        this.store.subscribe( watchCategoriesSel( (newVal, oldVal, path) => this.setActive( this.store.getState().selectCategories ) ) );
    }

    setActive(){
        let _num = this.store.getState().selectCategories;
        $( this.el + ' .gd-filter-list li' ).removeClass('is-active');
        $( this.el + ' button.gd-filter-list-title' ).removeClass('is-active');
        
        if (!_num) {
            $( this.el + ' button.gd-filter-list-title' ).addClass('is-active');
            return false;
        }
        
        let currentPar = $( this.el + ' .gd-filter-list' );
        let current = {};
        try {
            current = currentPar.find(`li[data-categoryid=${_num}]`);
        } catch (e) {
            $( this.el + ' button.gd-filter-list-title' ).addClass('is-active');
            return false;
        }
        
        if (current.length>0) {
            current.addClass('is-active');
            if(current.parent().hasClass('gd-filter-list-inner')){
                current.parent().parent().addClass('is-active');
            }
        }
    }

    addEvents(){
        $( this.el + ' .gd-filter-list li>button' ).on('click', (e)=>{
            // this.store.dispatch( this.actions.setStopListLoad(true) );
            // this.store.dispatch( this.actions.setListpage( 1 ) );
            
            this.router.goMultiParamSetListPage( {'category':  $(e.currentTarget).data('categoryid')} );
            
            // this.store.dispatch( this.actions.setStopListLoad(false) );
            // this.store.dispatch( this.actions.loadItemList(1) );
        });
        
        $( this.el + ' button.gd-filter-list-title' ).on('click', (e)=>{
            // this.store.dispatch( this.actions.setStopListLoad(true) );
            // this.store.dispatch( this.actions.setListpage( 1 ) );
            
            this.router.goMultiParamSetListPage( {'category': ''} );
            
            // this.store.dispatch( this.actions.setStopListLoad(false) );
            // this.store.dispatch( this.actions.loadItemList(1) );
        });
    }




} // end of class
export default CategoriesItem;